import { Outlet } from "react-router";
import { IConfigurationPageProps } from "./interface";

const ConfigurationPage: React.FC<IConfigurationPageProps> = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default ConfigurationPage;
